import { useCallback, useEffect, useRef } from "react";

// Restituisce una funzione da chiamare ad ogni digitazione: dopo almeno `minChars`
// caratteri e `delay` ms senza altra digitazione esegue `cerca(testo)`.
// Se il testo contiene `separatore` e' un'opzione gia' scelta dalla lista e non si cerca.
const useLocalitaSearch = (cerca, { minChars = 3, delay = 500 } = {}) => {
  const timer = useRef(null);
  const cercaRef = useRef(cerca);
  cercaRef.current = cerca;

  useEffect(() => () => clearTimeout(timer.current), []);

  return useCallback(
    (testo, separatore) => {
      clearTimeout(timer.current);
      const t = (testo || "").trim();
      if (t.length < minChars || (separatore && t.includes(separatore))) return;
      timer.current = setTimeout(() => cercaRef.current(t), delay);
    },
    [minChars, delay]
  );
};

export default useLocalitaSearch;
